import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Amenities from "@/components/site/Amenities";
import Gallery from "@/components/site/Gallery";
import ValueProps from "@/components/site/ValueProps";
import BusinessTravelers from "@/components/site/BusinessTravelers";
import Location from "@/components/site/Location";
import PapenburgDiscover from "@/components/site/PapenburgDiscover";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import BookingCTA from "@/components/site/BookingCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
    return (
        <div data-testid="home-page" className="bg-background text-foreground">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Amenities />
                <Gallery />
                <ValueProps />
                <BusinessTravelers />
                <Location />
                <PapenburgDiscover />
                <Pricing />
                <FAQ />
                <BookingCTA />
            </main>
            <Footer />
        </div>
    );
}
